module.exports = __webpack_public_path__ + "img/photo-17.b5149aae.jpg";